module.exports = __webpack_public_path__ + "static/media/Nurse_using_Curoflow_telemedicine_platform_at_primary_care_clinic.d8299439.webp";